<template>
    <div class="panel-body">
        <div class="panel-nav">
            <button class="close-button" v-on:click.prevent="closePanel"></button>
        </div>
        <div class="scroller padded">
            <h2 class="panel-header">POI/PDI</h2>

                <h3>Installazione POI maggiori navigatori GPS</h3>

                <ul class="list">
                    <li class="row-even"><p><a :href="'https://garmin.gps-data-team.com/conversion.php?format=csv&poi_file=forum.ecomotori.net/poigenerator/Ecomotori' + this.fuel_name.replace(' ','_') + this.country.iso + '.csv'" target="_blank">Garmin POI (csv)</a></p></li>
                    <li><p><a :href="'https://tomtom.gps-data-team.com/conversion.php?format=ov2&poi_file=forum.ecomotori.net/poigenerator/Ecomotori' + this.fuel_name + this.country.iso + '.csv'" target="_blank">TomTom POI (ov2)</a></p></li>
                    <li class="row-even"><p><a :href="'https://garmin.gps-data-team.com/conversion.php?format=csv&poi_file=forum.ecomotori.net/poigenerator/Ecomotori' + this.fuel_name.replace(' ','_') + this.country.iso + '.csv'" target="_blank">Navman POI (csv)</a></p></li>
                    <li><p><a :href="'https://garmin.gps-data-team.com/conversion.php?format=csv&poi_file=forum.ecomotori.net/poigenerator/Ecomotori' + this.fuel_name + this.country.iso + '.csv'" target="_blank">Navigon POI (csv)</a></p></li>
                    <li class="row-even"><p><a :href="'https://tomtom.gps-data-team.com/conversion.php?format=xls&poi_file=forum.ecomotori.net/poigenerator/Ecomotori' + this.fuel_name.replace(' ','_') + this.country.iso + '.csv'" target="_blank">CoPilot POI (xls)</a></p></li>
                    <li><p><a :href="'https://garmin.gps-data-team.com/conversion.php?format=mio&poi_file=forum.ecomotori.net/poigenerator/Ecomotori' + this.fuel_name + this.country.iso + '.csv'" target="_blank">MioMap POI (csv)</a></p></li>
                    <li class="row-even"><p><a :href="'https://garmin.gps-data-team.com/conversion.php?format=dat&poi_file=forum.ecomotori.net/poigenerator/Ecomotori' + this.fuel_name.replace(' ','_') + this.country.iso + '.csv'" target="_blank">Destinator POI (csv)</a></p></li>
                    <li><p><a :href="'https://garmin.gps-data-team.com/conversion.php?format=gpx&poi_file=forum.ecomotori.net/poigenerator/Ecomotori' + this.fuel_name + this.country.iso + '.csv'" target="_blank">GPX Exchange format (xml)</a></p></li>
                    <li class="row-even"><p><a :href="'https://tomtom.gps-data-team.com/conversion.php?format=kml&poi_file=forum.ecomotori.net/poigenerator/Ecomotori' + this.fuel_name.replace(' ','_') + this.country.iso + '.csv'" target="_blank">Google Earth format (kml)</a></p></li>
                    <li><p><a :href="'https://garmin.gps-data-team.com/conversion.php?format=lmx&poi_file=forum.ecomotori.net/poigenerator/Ecomotori' + this.fuel_name + this.country.iso + '.csv'" target="_blank">Nokia LMX POI format</a></p></li>
                    <li class="row-even"><p><a :href="'https://garmin.gps-data-team.com/conversion.php?format=GPX&poi_file=forum.ecomotori.net/poigenerator/Ecomotori' + this.fuel_name.replace(' ','_') + this.country.iso + '.csv'" target="_blank">Garmin direct POI upload</a></p></li>
                    <li><p><a :href="'https://forum.ecomotori.net/poigenerator/Ecomotori' + this.fuel_name.replace(' ','_') + this.country.iso + '.bmp'" target="_blank">Icona BMP</a></p></li>
                </ul>

                <div class="poi-footer">
                    <!--<p><a href="/_/guide/">Guide installazione POI</a></p>-->
                    <p><a href="https://tomtom.gps-data-team.com/conversion.php" target="_blank">POI conversion tools</a></p>
                    <p>by <a href="https://www.gps-data-team.com/" target="_blank">GPS Data Team</a></p>
                </div>

        </div>
    </div>
</template>

<script>

    import { serverBus } from '../main';
    import Fuels from '../models/fuels';

    export default {
        methods: {
            closePanel() {
                serverBus.$emit("closePanel");
            },
            loadData(_position) {
                this.fuel = this.$parent.$parent.$parent.$parent.fuel;
                this.fuel_name = Fuels.getById(this.fuel).name;

                if(_position) {
                    this.country = _position.country;
                } else {
                    this.country = this.$parent.$parent.$parent.$parent.country;
                }
            }
        },
        data() {
            return {
                fuel: null,
                country: null,
                fuel_name: null,
                country_name: null
            };
        },
        created() {
            serverBus.$on('areaChanged',this.loadData);
            serverBus.$emit('pageChanged',{page:'MapPDI'});
            this.loadData(false);
        }
    }

</script>
<style lang="scss">
    #ecomotoriMap {
      a {
          color: black;
      }
      .add-poi {
          display: block;
          text-align: center;
      }
      .poi-footer {
          p {
              line-height: 8px;
          }
          font-size: 14px;
      }
    }
</style>
